export const navigateToNewAppMixin = {
  methods: {
    navigateToNewApp (route) {
      const data = {
        token: localStorage.getItem('token'),
        user: localStorage.getItem('user'),
        permissions: localStorage.getItem('permissions'),
        route
      }

      const jsonString = JSON.stringify(data)
      const payload = btoa(unescape(encodeURIComponent(jsonString)))

      window.location.href = `${process.env.VUE_APP_NEW_URL}#handover=${payload}`
    }
  }
}
